export const PRODUCTS = [
  {
    id: "tiger-tee-01",
    title: "Fierce Tiger Roar Oversized Tee",
    price: 34.99,
    currency: "GBP",
    category: "T-Shirts",
    image: "/assets/mockup-hero.jpg",
    secondaryImage: "/assets/mockup-4.jpg",
    badge: "BESTSELLER",
    description: "Our signature oversized tee with the roaring tiger chest print. Heavyweight 240 GSM organic cotton with a boxy streetwear fit and ribbed collar.",
    defaultColor: "Orange",
    colors: [
      { name: "Orange", swatch: "#FF5500", image: "/assets/mockup-hero.jpg" },
      { name: "Black", swatch: "#0A0A0B", image: "/assets/mockup-5.jpg" },
      { name: "Gold", swatch: "#C9A227", image: "/assets/mockup-3.jpg" },
      { name: "Amber Box", swatch: "#E8A13D", image: "/assets/mockup-2.jpg" },
    ],
  },
  {
    id: "tiger-tee-02",
    title: "Urban Beast Back-Print Tee",
    price: 32.99,
    currency: "GBP",
    category: "T-Shirts",
    image: "/assets/mockup-5.jpg",
    secondaryImage: "/assets/mockup-1.jpg",
    badge: "NEW DROP",
    description: "Clean front, statement back. Oversized tiger artwork printed across the back with a small chest mark. Heavyweight cotton, true-to-size fit.",
    defaultColor: "Black",
    colors: [
      { name: "Black", swatch: "#0A0A0B", image: "/assets/mockup-5.jpg" },
      { name: "Orange", swatch: "#FF5500", image: "/assets/mockup-hero.jpg" },
      { name: "Gold", swatch: "#C9A227", image: "/assets/mockup-3.jpg" },
      { name: "Amber Box", swatch: "#E8A13D", image: "/assets/mockup-2.jpg" },
    ],
  },
  {
    id: "tiger-hoodie-01",
    title: "Fierce Attire Heavyweight Hoodie",
    price: 64.99,
    currency: "GBP",
    category: "Hoodies",
    image: "/assets/mockup-6.jpg",
    secondaryImage: "/assets/mockup-3.jpg",
    badge: "240 GSM",
    description: "The heavyweight staple. Brushed fleece interior, double-lined hood, kangaroo pocket and the Fierce Attire tiger mark on the chest.",
  },
  {
    id: "tiger-hoodie-02",
    title: "Tiger Stripe Acid Wash Hoodie",
    price: 69.99,
    currency: "GBP",
    category: "Hoodies",
    image: "/assets/mockup-3.jpg",
    secondaryImage: "/assets/mockup-6.jpg",
    badge: "LIMITED",
    description: "Limited run acid wash hoodie — every piece has a unique wash pattern. Tiger stripe sleeve print and embroidered chest logo.",
  },
  {
    id: "tiger-cap-01",
    title: "Night Prowl Snapback Cap",
    price: 24.99,
    currency: "GBP",
    category: "Accessories",
    image: "/assets/mockup-1.jpg",
    secondaryImage: "/assets/mockup-5.jpg",
    badge: "NEW DROP",
    description: "Structured six-panel snapback with embroidered tiger eye mark. One size, adjustable strap.",
  },
  {
    id: "tiger-tee-03",
    title: "Street Hunter Graphic Tee",
    price: 29.99,
    currency: "GBP",
    category: "T-Shirts",
    image: "/assets/mockup-4.jpg",
    secondaryImage: "/assets/mockup-hero.jpg",
    badge: "ORGANIC",
    description: "Everyday organic cotton tee with a tonal tiger stripe graphic. Soft-hand print, regular fit.",
    defaultColor: "Orange",
    colors: [
      { name: "Orange", swatch: "#FF5500", image: "/assets/mockup-4.jpg" },
      { name: "Black", swatch: "#0A0A0B", image: "/assets/mockup-1.jpg" },
      { name: "Gold", swatch: "#C9A227", image: "/assets/mockup-3.jpg" },
      { name: "Amber Box", swatch: "#E8A13D", image: "/assets/mockup-2.jpg" },
    ],
  },
];

export const SIZES = ["S", "M", "L", "XL", "XXL"];

export const SIZE_GUIDE = [
  { size: "S", chest: '34-36"', length: '27"' },
  { size: "M", chest: '38-40"', length: '28"' },
  { size: "L", chest: '42-44"', length: '29"' },
  { size: "XL", chest: '46-48"', length: '30"' },
  { size: "XXL", chest: '50-52"', length: '31"' },
];

export const PRINT_SPECS = [
  "240 GSM heavyweight 100% organic cotton",
  "High-density DTG print — crisp, soft-hand feel",
  "Printed on demand & fulfilled via Printful",
  "Machine wash cold, inside out",
];

export const formatPrice = (value) => `£${Number(value).toFixed(2)}`;
